// Hero / Intro section content
export const hero = {
  eyebrow: 'Introducing SlideFactory',
  headline: `AI-Powered Presentations
at Enterprise Scale.`,
  subheadline: `Transform ideas, data, and documents into polished PowerPoint presentations in seconds.
Powered by multiple AI providers, integrated with your workflows, and built for enterprise security.`,
  buttons: [
    { label: 'Explore Features', href: '#features', style: 'stroke' },
    { label: 'Request Demo', href: '#cta', style: 'stroke' }
  ]
}
